import React from 'react';
import classNames from 'classnames';
import cls from './ProjectTeamForemenRow.module.css';
import { useProjectTeamForemenRow } from './useProjectTeamForemenRow';
import { CardList } from '../../UI/CardList/CardList';
import { PeopleCard } from '../../UI/PeopleCard/PeopleCard';
import { CardTitle } from '../../UI/CardTitle/CardTitle';
import { CardType, InviteCard } from '../../UI/InviteCard/InviteCard';
import { OpenedInviteCard } from '../../useProjectTeamInvite';
import { EmployersForSelect } from '../../../../../TemporaryConmonents/AddProject/SecondStep/useSecondStep';
import { Roles } from '../../../../../TemporaryConmonents/AddProject/types/types';
import { useTranslation } from 'react-i18next';

interface ProjectTeamForemenRowProps {
    classes?: string;
    openedInviteCard: OpenedInviteCard;
    onOpenedInviteCardChange: (value: OpenedInviteCard) => void;
    employersList: EmployersForSelect[];
    onEmployersListSet: (value: string) => void;
    closingCard: string;
    onSetClosingCard: (value: string) => void;
}

export const ProjectTeamForemenRow = ({
    classes,
    openedInviteCard,
    onOpenedInviteCardChange,
    onEmployersListSet,
    employersList,
    onSetClosingCard,
    closingCard,
}: ProjectTeamForemenRowProps) => {
    const { foremans } = useProjectTeamForemenRow();
    const { t } = useTranslation();
    return (
        <div className={classNames(cls.ProjectTeamForemenRow, [classes])}>
            <CardTitle
                title={t('ProjectTeam.ProjectTeamInvite.ProjectTeamForementRow.CardTitle')}
                role={Roles.FOREMAN}
            />
            <CardList>
                <InviteCard
                    closingCard={closingCard}
                    onSetClosingCard={onSetClosingCard}
                    onEmployersListSet={onEmployersListSet}
                    employersList={employersList}
                    type={CardType.FOREMAN}
                    openedInviteCard={openedInviteCard}
                    onOpenedInviteCardChange={onOpenedInviteCardChange}
                />
                {foremans.ids.map((id) => (
                    <PeopleCard employerId={id} />
                ))}
            </CardList>
        </div>
    );
};
